import { Tgt_Inst } from './tgt_inst';
import { RepConn } from '../datapoint/repconn';
import { DataObject } from './dataobject';
import { CommonEnums } from 'src/app/shared/common.enums';
import { MJnr_Inst_Cnd } from './mjnr_inst_cnd';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Tgt_Attr_Lnk } from './tgt_attr_lnk';
import { Obj_Db_PropertiesUtil } from '../../utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from '../../utils/db_propertytypes.util';
import { Tgt_Attr_LnksUtil } from '../../utils/tgt_attr_lnks.util';
import { MJnr_Inst_CndsUtil } from '../../utils/mJnr_inst_cnds.util';

export class Target {
    tgt_Inst: Tgt_Inst;
    tgt_Attr_Lnks: Array<Tgt_Attr_Lnk>;
    mJnr_Inst_Cnds: Array<MJnr_Inst_Cnd>;
    load_Properties: Array<Obj_Db_Property>;
    extract_Properties: Array<Obj_Db_Property>;
    dataObject: DataObject;
    nativeDbTyp_Id: number;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number
    imageUrl: string;
    sel_Load_PropertyType_Cd: string;
    loadPropertyTypes: Array<Db_PropertyType>;
    isNativeFlg: boolean;
    sel_Extract_PropertyType_Cd: string;
    extractPropertyTypes: Array<Db_PropertyType>;
    repConn: RepConn;
    sel_Run_PropertyType_Cd: string;
    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;
    properties: Array<Obj_Db_Property>;

    gen_Tab_Change_Ind: string;
    prop_Tab_Change_Ind: string;
    attr_Tab_Change_Ind: string;
    attrMapr_Tab_Change_Ind: string;
    eprop_Tab_Change_Ind: string;
    lprop_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;

    constructor() {
        this.setDefault()
    }

    setDefault(): void {
        this.tgt_Inst = new Tgt_Inst();
        this.dataObject = new DataObject();

        this.tgt_Attr_Lnks = new Array<Tgt_Attr_Lnk>();
        this.mJnr_Inst_Cnds = new Array<MJnr_Inst_Cnd>();

        this.nativeDbTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.imageUrl = CommonEnums.defaults.STRING_EMPTY;

        this.sel_Load_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.sel_Extract_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.isNativeFlg = true;

        this.load_Properties = new Array<Obj_Db_Property>();
        this.extract_Properties = new Array<Obj_Db_Property>();
        this.run_Properties = new Array<Obj_Db_Property>();
        this.properties = new Array<Obj_Db_Property>();

        this.loadPropertyTypes = new Array<Db_PropertyType>();
        this.extractPropertyTypes = new Array<Db_PropertyType>();
        this.runPropertyTypes = new Array<Db_PropertyType>();

        this.repConn = new RepConn();

        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.prop_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.attrMapr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.eprop_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.lprop_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
    }

    static parse(targetTmp: Target): Target {
        let target: Target = new Target();
        target.copyFrom(targetTmp);
        return target;
    }

    copy(): Target {
        let targetTmp: Target = new Target();

        targetTmp.tgt_Inst = this.tgt_Inst.copy();

        targetTmp.dataObject = this.dataObject;
        targetTmp.repConn = this.repConn;

        targetTmp.tgt_Attr_Lnks = Tgt_Attr_LnksUtil.getInstance().copy(this.tgt_Attr_Lnks);
        targetTmp.mJnr_Inst_Cnds = MJnr_Inst_CndsUtil.getInstance().copy(this.mJnr_Inst_Cnds);

        targetTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        targetTmp.change_Ind = this.change_Ind;
        targetTmp.error_Cd = this.error_Cd;
        targetTmp.error_Msg = this.error_Msg;
        targetTmp.ref_Id = this.ref_Id;
        targetTmp.ref_Cd = this.ref_Cd;
        targetTmp.fldr_Id = this.fldr_Id;
        targetTmp.imageUrl = this.imageUrl;

        targetTmp.sel_Load_PropertyType_Cd = this.sel_Load_PropertyType_Cd;
        targetTmp.sel_Extract_PropertyType_Cd = this.sel_Extract_PropertyType_Cd;
        targetTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
        targetTmp.isNativeFlg = this.isNativeFlg;

        let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
        targetTmp.load_Properties = obj_Db_PropertiesUtil.copy(this.load_Properties);
        targetTmp.extract_Properties = obj_Db_PropertiesUtil.copy(this.extract_Properties);
        targetTmp.run_Properties = obj_Db_PropertiesUtil.copy(this.run_Properties)
        targetTmp.properties = obj_Db_PropertiesUtil.copy(this.properties);

        let db_PropertyTypesUtil: Db_PropertyTypesUtil = Db_PropertyTypesUtil.getInstance();
        targetTmp.loadPropertyTypes = db_PropertyTypesUtil.copy(this.loadPropertyTypes);
        targetTmp.extractPropertyTypes = db_PropertyTypesUtil.copy(this.extractPropertyTypes);
        targetTmp.runPropertyTypes = db_PropertyTypesUtil.copy(this.runPropertyTypes);

        targetTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        targetTmp.prop_Tab_Change_Ind = this.prop_Tab_Change_Ind;
        targetTmp.attr_Tab_Change_Ind = this.attr_Tab_Change_Ind;
        targetTmp.attrMapr_Tab_Change_Ind = this.attrMapr_Tab_Change_Ind;
        targetTmp.eprop_Tab_Change_Ind = this.eprop_Tab_Change_Ind;
        targetTmp.lprop_Tab_Change_Ind = this.lprop_Tab_Change_Ind;
        targetTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;

        return targetTmp;
    }

    copyFrom(targetTmp: Target): void {
        this.tgt_Inst.copyFrom(targetTmp.tgt_Inst);

        this.dataObject = targetTmp.dataObject;
        this.repConn = targetTmp.repConn;

        Tgt_Attr_LnksUtil.getInstance().copyFrom(this.tgt_Attr_Lnks, targetTmp.tgt_Attr_Lnks);
        MJnr_Inst_CndsUtil.getInstance().copyFrom(this.mJnr_Inst_Cnds, targetTmp.mJnr_Inst_Cnds);

        this.nativeDbTyp_Id = targetTmp.nativeDbTyp_Id;
        this.change_Ind = targetTmp.change_Ind;
        this.error_Cd = targetTmp.error_Cd;
        this.error_Msg = targetTmp.error_Msg;
        this.ref_Id = targetTmp.ref_Id;
        this.ref_Cd = targetTmp.ref_Cd;
        this.fldr_Id = targetTmp.fldr_Id;
        this.imageUrl = targetTmp.imageUrl;

        this.sel_Load_PropertyType_Cd = targetTmp.sel_Load_PropertyType_Cd;
        this.sel_Extract_PropertyType_Cd = targetTmp.sel_Extract_PropertyType_Cd;
        this.sel_Run_PropertyType_Cd = targetTmp.sel_Run_PropertyType_Cd;
        this.isNativeFlg = targetTmp.isNativeFlg;

        let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
        obj_Db_PropertiesUtil.copyFrom(this.load_Properties, targetTmp.load_Properties);
        obj_Db_PropertiesUtil.copyFrom(this.extract_Properties, targetTmp.extract_Properties);
        obj_Db_PropertiesUtil.copyFrom(this.run_Properties, targetTmp.run_Properties);
        obj_Db_PropertiesUtil.copyFrom(this.properties, targetTmp.properties);

        let db_PropertyTypesUtil: Db_PropertyTypesUtil = Db_PropertyTypesUtil.getInstance();
        db_PropertyTypesUtil.copyFrom(this.loadPropertyTypes, targetTmp.loadPropertyTypes);
        db_PropertyTypesUtil.copyFrom(this.extractPropertyTypes, targetTmp.extractPropertyTypes);
        db_PropertyTypesUtil.copyFrom(this.runPropertyTypes, targetTmp.runPropertyTypes);

        this.gen_Tab_Change_Ind = targetTmp.gen_Tab_Change_Ind;
        this.prop_Tab_Change_Ind = targetTmp.prop_Tab_Change_Ind;
        this.attr_Tab_Change_Ind = targetTmp.attr_Tab_Change_Ind;
        this.attrMapr_Tab_Change_Ind = targetTmp.attrMapr_Tab_Change_Ind;
        this.eprop_Tab_Change_Ind = targetTmp.eprop_Tab_Change_Ind;
        this.lprop_Tab_Change_Ind = targetTmp.lprop_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = targetTmp.rProp_Tab_Change_Ind;
    }

    compare(targetTmp: Target): string {
        let targetString: string = this.toString();
        let targetTmpString: string = targetTmp.toString();

        if (targetString != targetTmpString) {
            return targetString + ', ' + targetTmpString;
        }

        return '';
    }

    toString(): string {
        let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
        let db_PropertyTypesUtil: Db_PropertyTypesUtil = Db_PropertyTypesUtil.getInstance();
        return "Target [ tgt_Inst=" + this.tgt_Inst.toString() +
            ", tgt_Attr_Lnks=" + Tgt_Attr_LnksUtil.getInstance().toString(this.tgt_Attr_Lnks) +
            ", mJnr_Inst_Cnds=" + MJnr_Inst_CndsUtil.getInstance().toString(this.mJnr_Inst_Cnds) +
            ", load_Properties=" + obj_Db_PropertiesUtil.toString(this.load_Properties) +
            ", extract_Properties=" + obj_Db_PropertiesUtil.toString(this.extract_Properties) +
            ", dataObject=" + this.dataObject.toString() + ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
            ", change_Ind=" + this.change_Ind + ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
            ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd + ", fldr_Id=" + this.fldr_Id +
            ", imageUrl=" + this.imageUrl + ", sel_Load_PropertyType_Cd=" + this.sel_Load_PropertyType_Cd +
            ", loadPropertyTypes=" + db_PropertyTypesUtil.toString(this.loadPropertyTypes) +
            ", isNativeFlg=" + this.isNativeFlg + ", sel_Extract_PropertyType_Cd=" + this.sel_Extract_PropertyType_Cd +
            ", extractPropertyTypes=" + db_PropertyTypesUtil.toString(this.extractPropertyTypes) +
            ", repConn=" + this.repConn.toString() + ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd +
            ", run_Properties=" + obj_Db_PropertiesUtil.toString(this.run_Properties) +
            ", runPropertyTypes=" + db_PropertyTypesUtil.toString(this.runPropertyTypes) +
            ", properties=" + obj_Db_PropertiesUtil.toString(this.properties) +
            ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind + ", prop_Tab_Change_Ind=" + this.prop_Tab_Change_Ind +
            ", attr_Tab_Change_Ind=" + this.attr_Tab_Change_Ind + ", attrMapr_Tab_Change_Ind=" + this.attrMapr_Tab_Change_Ind +
            ", eprop_Tab_Change_Ind=" + this.eprop_Tab_Change_Ind + ", lprop_Tab_Change_Ind=" + this.lprop_Tab_Change_Ind +
            ", rProp_Tab_Change_Ind=" + this.rProp_Tab_Change_Ind + "]";
    }
}

